export default __webpack_public_path__ + "static/media/gallery_11.c4c7981a.jpg";